import type { IActivity, IProcessAction, IProcessActivity } from '@common/interfaces';

export function findProcessAction(
    processActivity: IProcessActivity,
    processActions?: IProcessAction[]
): IProcessAction | undefined {
    return processActions?.find((processAction) => findProcessActionActivity(processActivity, processAction));
}

export function findProcessActionActivity(
    processActivity: IProcessActivity,
    processAction?: IProcessAction
): IActivity | undefined {
    return processAction?.activities?.find(
        (processActionActivity) => processActionActivity.processActivityId === processActivity.id
    );
}
